import React from 'react'
import Portal from '../../../../component/portal'
import { AppContext } from '../../../../config/context'
import Login from '../../../../component/login'
import BlackList from '../../../../component/blackList'
import { getProductSet, orderProductSet } from './service'
import { getImgUrl, showDiscount, createNativeForm, safeParse, i18n, getPLink, parseDateToTimestamp, formatTimeForSeckill } from '../../../../common/util'
import './index.scss'
import ee, { EVENT_TIP } from '../../../../common/util/event'

class ProductSet extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            goodsId: window._inject_app_data_.goodsId,
            page: 1,
            pageSize: 5,
            setList: [],
            showLoginModal: false,
            showBlackListTip: false,
            blackListTipContent: '',
            index: 0,
            now: 0,
            serverNow: 0,
            hour: '00',
            min: '00',
            sec: '00'
        }
        this.timer = null
        this.submitFlag = false
    }

    componentDidMount() {
        this.loadProductSet()
    }

    loadProductSet = () => {
        const { goodsId, page, pageSize } = this.state
        getProductSet(goodsId, page, pageSize).then(({ entities }) => {
            let serverNow
            entities.forEach(e => {
                let primePrice = 0
                let discount = 0
                e.goodsList.forEach(g => {
                    g.goodsId = g.goodId
                    g.skuType !== 1 && (g.goodsName += `：${g.skuName}`)
                    primePrice += g.salePrice * 100
                    discount += g.discountPrice * 100
                })
                e.primePrice = (primePrice / 100).toFixed(2)
                e.discountValue = (discount / 100).toFixed(2)
                e.salePrice = ((primePrice - discount) / 100).toFixed(2)
                e.discount = showDiscount(primePrice - discount, primePrice)
                e.effectEndTime = parseDateToTimestamp(e.effectEndTime)
                serverNow = e.now
            })
            const now = Date.now()
            this.setState({
                setList: entities,
                now,
                serverNow
            })
            serverNow && this.startTimer(now, serverNow, entities[0].effectEndTime)
        })
    }

    startTimer = (now, serverNow, endTime) => {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
        const startTime = serverNow + (Date.now() - now)
        if (startTime >= endTime) {
            return this.setState({
                hour: '',
                min: '',
                sec: ''
            })
        }
        let seconds = Math.ceil((endTime - startTime) / 1000)
        this.setState(formatTimeForSeckill(seconds))
        this.timer = setInterval(() => {
            --seconds
            if (seconds >= 0) {
                this.setState(formatTimeForSeckill(seconds))
            } else {
                clearInterval(this.timer)
                this.timer = null
                this.setState({
                    hour: '',
                    min: '',
                    sec: ''
                })
            }
        }, 1000)
    }

    closeLoginModal = () => {
        this.setState({
            showLoginModal: false
        })
    }

    closeBlackListTip = () => {
        this.setState({ showBlackListTip: false })
    }

    changeIndex = index => {
        if (index === this.state.index) {
            return
        }
        this.setState({
            index
        })
        const { setList, now, serverNow } = this.state
        this.startTimer(now, serverNow, setList[index].effectEndTime)
    }

    submit = () => {
        if (this.context.user.isLogin !== 1) {
            return this.setState({
                showLoginModal: true
            })
        }
        if (this.submitFlag) {
            return
        }
        this.submitFlag = true
        const { index, setList } = this.state
        const { activityType, id: activityId, name: activityName, goodsList } = setList[index]
        orderProductSet(activityType, activityId, goodsList.map(l => ({ skuId: l.skuId, num: 1 }))).then(data => {
            const { payAmount, subOrders, isQq, reductionAmount: discountValue } = data
            subOrders.forEach(so => {
                so.extDesc = safeParse(so.extDesc)
            })
            const { goodsId } = this.state
            createNativeForm({
                action: '/order/confirm',
                data: {
                    goodsId,
                    activityType,
                    activityId,
                    activityName,
                    discountValue,
                    isQq,
                    payAmount,
                    subOrders: JSON.stringify(subOrders)
                }
            }).submit()
        }).catch(e => {
            if (e.code === 403) {
                this.setState({
                    showBlackListTip: true,
                    blackListTipContent: e.message
                })
            } else if (e.code !== 401) {
                ee.emit(EVENT_TIP, e.message)
            }
        }).finally(() => {
            this.submitFlag = false
        })
    }

    render() {
        const { setList, showLoginModal, showBlackListTip, blackListTipContent, index, hour, min, sec } = this.state
        const { lang } = this.context.user
        const current = setList[index]
        return setList.length > 0 ? <div className="product-set-wrapper">
            <ul className='product-set-navs'>
                {
                    setList.map((i, ii) => (<li className={ii === index ? 'product-set-nav active' : 'product-set-nav'} key={i.id} onClick={() => this.changeIndex(ii)}>{i18n(i.name, lang)}</li>))
                }
            </ul>
            <div className='product-set-content'>
                <p className='product-set-tip'>{i18n('购买此套餐，所有商品立省', lang)}<span className='highlight'>&yen;{current.discountValue}</span></p>
                <ul className='product-set-ul'>
                    {
                        current.goodsList.map(g => (<a target='_blank' href={getPLink(g) + (g.skuType === 1 ? '' : `?spec=${g.skuId}`)} key={g.goodsId}>
                            <li className='product-set-item'>
                                <img alt='' className='img' src={getImgUrl(g.mainPic || g.imgUrl)}></img>
                                <div className='name'>{i18n(g.goodsName)}</div>
                            </li>
                        </a>))
                    }
                </ul>
                <div className='product-set-info'>
                    <div className='right'>
                        <div className='discount-wrapper'>
                            <div className='discount'>{current.discount}</div>
                        </div>
                        <div className='price-wrapper'>
                            <p className='price'>&yen;{current.salePrice}</p>
                            <p className='op'>&yen;{current.primePrice}</p>
                        </div>
                        <div className='submit-wrapper'>
                            <button className='submit-btn' onClick={this.submit}>{i18n('购买套餐', lang)}</button>
                        </div>
                    </div>
                    {
                        hour.length
                            ? <p className='timer'>{hour}:{min}:{sec}<span className='timer-tip'>{i18n('后活动结束', lang)}</span></p>
                            : <p className='timer'><span className='timer-tip over'>{i18n('活动已结束', lang)}</span></p>
                    }
                </div>
            </div>
            {showBlackListTip && <BlackList close={this.closeBlackListTip} content={blackListTipContent}></BlackList>}
            {showLoginModal && <Login close={this.closeLoginModal}></Login>}
        </div> : null
    }
}

ProductSet.contextType = AppContext
export default Portal(ProductSet, 'product-set-container')